import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Util from '../../Classes/Utils';
import Slider2 from '../../Images/shopBanner/SLIDER 2.jpg';
import { FaListUl, FaGripHorizontal } from 'react-icons/fa';
import { AddItemToWishList, GetAllProducts, GetWishListItems, RemoveItemFromWishList } from '../Data';
import ProductGridAR from '../Common/ProductGridAR';
import ProductListAR from '../Common/ProductListAR';
import Pagination from '../Pagination/Pagination';
import { toast } from 'react-toastify';
import CategoryAR from '../Category/CategoryAR';
import ProductModalAR from '../Common/ProductModalAR';
import CategorySliderAR from '../Home/CategorySlider/CategorySliderAR';
import Cookies from 'js-cookie';



const ShopAR = () => {
    const [showList, setShowList] = useState("grid");
    const [showModal, setShowModal] = useState(false);
    const [productDetails, setProductDetails] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [isLogged, setIsLogged] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [WishListItems, setWishListItems] = useState([]);
    const [shopItems, setShopItems] = useState([]);
    const [shopItemsCount, setShopItemsCount] = useState(0);

    const token = Cookies.get("CustomerToken");

    // const [test,setTest] = useState({
    // 	products: [],
    // 	productCount: 0
    // })


    const navigate = useNavigate();
    let LIMIT = 9;
    let a = 0;

    const GetAllProductsForShop = useMemo(() => {
        const offset = new Date().getTimezoneOffset();

        GetAllProducts(currentPage, LIMIT).then((Result) => {
            setShopItems(Result.finalList);
            setShopItemsCount(Result.count);
            //   test.products = Result.finalList
            //   test.productCount = Result.count

        })

    }, [currentPage])


    const GetWishListItemsForShop = () => {
        var groupId;
        if (Cookies.get("WishList") !== undefined) {
            groupId = 4
        } else {
            groupId = 3
        }
        const getItem = (Cookies.get('WishList') !== undefined);
        if (getItem) {
            var WishlistId = Cookies.get("WishList");
            GetWishListItems(WishlistId, groupId, token).then((Result) => {
                setWishListItems(Result.WishlistItems);
            });
        }
    }

    const HandleAddToWishList = (ProductId, ProductVariationId) => {
        if (!isLogged) {
            navigate('/Authentication');
            return;
        }

        const WishlistId = Cookies.get("WishList");
        if (!WishlistId) return;

        AddItemToWishList(WishlistId, ProductId, ProductVariationId, token)
            .then((response) => {
                if (!response.ok) throw new Error();

                toast.success("تمت الإضافة إلى المفضلة");

                // ✅ UPDATE STATE (IMPORTANT)
                setWishListItems(prev => [
                    ...prev,
                    {
                        ProductId,
                        DefaultProductVariationId: ProductVariationId
                    }
                ]);
            })
            .catch(() => {
                toast.error("تعذر الإضافة");
            });
    };


    const HandleRemoveFromWishList = (ProductId) => {
        if (!isLogged) {
            navigate('/Authentication');
            return;
        }

        const WishlistId = Cookies.get("WishList");
        if (!WishlistId) return;

        RemoveItemFromWishList(ProductId, WishlistId, token)
            .then((response) => {
                if (!response.ok) throw new Error();

                toast.success("تمت الإزالة من المفضلة");

                // ✅ UPDATE STATE (IMPORTANT)
                setWishListItems(prev =>
                    prev.filter(item => item.ProductId !== ProductId)
                );
            })
            .catch(() => {
                toast.error("تعذر الإزالة");
            });
    };

    const handleCategoryChange = () => {
        setCurrentPage(1);        // ✅ reset pagination
        window.scrollTo({ top: 0, behavior: 'smooth' }); // ✅ scroll top
    };

    useEffect(() => {
        setIsLoading(true);
        if (Cookies.get("CustomerToken") === null) {
            setIsLogged(false);
        } else {
            setIsLogged(true);
        }

        GetWishListItemsForShop();
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }, [])

    return (
        <>
            <div className="breadcrumb-area mb-5 ">
                <div className="container ">
                    <div className="row ">
                        <div className="col ">
                            <div className="breadcrumb-container  d-flex flex-row-reverse   ">
                                <div className="breadcrumbArabic HomeShop">
                                    <ul>
                                        <li className="active">تسوق</li>
                                        <li><a style={{ direction: 'rtl' }} href="index.html"><i className="fa fa-home"></i>
                                            المنزل</a></li>


                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {
                isLoading ? (
                    <div className="spinner-container">
                        <div className="loading-spinner"></div>
                    </div>
                ) : (
                    <>
                        <div className="shop-page-container mb-5">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-4 order-2">

                                        <div className="sidebar-area">

                                            <div className="sidebar mb-3 directionRtl">


                                                <CategoryAR onCategoryClick={handleCategoryChange} />

                                            </div>
                                            <div className="">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 order-1 mb-sm-3 mb-xs-3">


                                        <div className="shop-page-banner mb-3">
                                            <a href="shop-left-sidebar.html">
                                                <img width="870" height="331" src={Slider2}
                                                    alt="" />
                                            </a>
                                        </div>

                                        <div className="shop-header mb-3 mt-2 directionRtl">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-sm-12 d-flex align-items-center">

                                                    <div className="view-mode-icons mb-xs-1 directionLtr">
                                                        <a className={showList.includes("grid") ? "active" : ""} data-target="grid" onClick={() => setShowList('grid')}><FaGripHorizontal /></a>
                                                        <a className={showList.includes("list") ? "active" : ""} data-target="list" onClick={() => setShowList('list')}><FaListUl /></a>
                                                    </div>


                                                </div>
                                                <div
                                                    className="col-lg-8 col-md-8 col-sm-12 d-flex flex-column flex-sm-row justify-content-between align-items-left align-items-sm-center">

                                                    <div className="sort-by-dropdown d-flex align-items-center mb-xs-1">

                                                    </div>


                                                </div>
                                            </div>
                                        </div>



                                        <div className={"shop-product-wrap row no-gutters mb-3 " + showList} >

                                            {
                                                shopItems.map((product, index) => {
                                                    return (
                                                        <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                                            <ProductGridAR product={product}
                                                                WishListItems={WishListItems}
                                                                setShowModal={setShowModal}
                                                                HandleAddToWishList={HandleAddToWishList}
                                                                HandleRemoveFromWishList={HandleRemoveFromWishList}
                                                                productDetails={productDetails}
                                                                setProductDetails={setProductDetails}
                                                            />

                                                            <ProductListAR product={product}
                                                                WishListItems={WishListItems}
                                                                HandleAddToWishList={HandleAddToWishList}
                                                                HandleRemoveFromWishList={HandleRemoveFromWishList}
                                                                setShowModal={setShowModal}
                                                                productDetails={productDetails}
                                                                setProductDetails={setProductDetails} />

                                                            {
                                                                showModal && (
                                                                    <ProductModalAR
                                                                        productDetails={productDetails}
                                                                        WishListItems={WishListItems}
                                                                        HandleAddToWishList={HandleAddToWishList}
                                                                        HandleRemoveFromWishList={HandleRemoveFromWishList}
                                                                        showModal={showModal}
                                                                        setShowModal={setShowModal}
                                                                    />
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }

                                        </div>



                                        <Pagination
                                            currentPage={currentPage}
                                            totalCount={shopItemsCount}
                                            pageSize={LIMIT}
                                            onPageChange={page => setCurrentPage(page)}
                                        />


                                        {/* <div className="pagination-container">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-lg-12 directionRtl">

                                                <div className="pagination-content text-center">
                                                    <ul>
                                                        <li><a className="active" href="#">1</a></li>
                                                        <li><a href="#">2</a></li>
                                                        <li><a href="#">3</a></li>
                                                        <li><a href="#">4</a></li>
                                                        <li><a href="#"><i className="fa fa-angle-left"></i></a></li>
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div> */}


                                    </div>
                                </div>
                                <CategorySliderAR />
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
}

export default ShopAR